import { render, staticRenderFns } from "./_TemplateWrapper.vue?vue&type=template&id=496c8f3c&scoped=true&"
import script from "./_TemplateWrapper.vue?vue&type=script&lang=js&"
export * from "./_TemplateWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496c8f3c",
  null
  
)

export default component.exports